import React from "react";
import { StyleConverter } from "./Components/StyleConverter";
import { Templates } from "./Components/Templates";
import { StructureImport } from "./Flows/StructureImport";
import { TimelineCreate } from "./Flows/TimelineCreate";
import { TimelineImport } from "./Flows/TimelineImport";
const FLOWS = {
    TimelineCreate,
    TimelineImport,
    StructureImport,
    StyleConverter,
    TemplateLibrary: Templates
};
export function Workflow({ type, onExit }) {
    const Flow = FLOWS[type];
    return /*#__PURE__*/ React.createElement(Flow, {
        type: type,
        onExit: onExit
    });
}
